import { render, staticRenderFns } from "./comment-importer-page.vue?vue&type=template&id=a3360e1e&"
import script from "./comment-importer-page.vue?vue&type=script&lang=js&"
export * from "./comment-importer-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports